// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PublicSchemaTypes from '../../../graphql/public/PublicSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type VerificationFieldsQueryVariables = PublicSchemaTypes.Exact<{ [key: string]: never; }>;


export type VerificationFieldsQuery = (
  { __typename?: 'Query' }
  & { organisation?: PublicSchemaTypes.Maybe<(
    { __typename?: 'OrganisationModelGQLBase' }
    & Pick<PublicSchemaTypes.OrganisationModelGqlBase, 'id'>
    & { accountNameLoginConfig?: PublicSchemaTypes.Maybe<(
      { __typename?: 'OrganisationAccountNameLoginConfigModel' }
      & { fields_config?: PublicSchemaTypes.Maybe<(
        { __typename?: 'FieldsConfigRecord' }
        & Pick<PublicSchemaTypes.FieldsConfigRecord, 'verificationFields'>
      )> }
    )>, features: (
      { __typename?: 'OrganisationFeatures' }
      & Pick<PublicSchemaTypes.OrganisationFeatures, 'account_name_login'>
    ) }
  )> }
);

export type VerifyUserMutationVariables = PublicSchemaTypes.Exact<{
  accountName: PublicSchemaTypes.Scalars['NonEmptyString'];
  input: PublicSchemaTypes.UserVerificationDataInput;
}>;


export type VerifyUserMutation = (
  { __typename?: 'Mutation' }
  & { organisation?: PublicSchemaTypes.Maybe<(
    { __typename?: 'OrganisationModelGQLBase' }
    & { userByVerificationData?: PublicSchemaTypes.Maybe<(
      { __typename?: 'UserModelBase' }
      & Pick<PublicSchemaTypes.UserModelBase, 'organisation_role'>
      & UserVerificationDetailFragment
    )> }
  )> }
);

export type UserVerificationDetailFragment = (
  { __typename?: 'UserModelBase' }
  & Pick<PublicSchemaTypes.UserModelBase, 'id' | 'first_name' | 'last_name' | 'display_name' | 'email' | 'phone_number' | 'account_name' | 'employee_id' | 'position' | 'area' | 'location' | 'department' | 'custom_1' | 'custom_2' | 'custom_3' | 'privacy_policy_accepted'>
);

export const UserVerificationDetailFragmentDoc = gql`
    fragment userVerificationDetail on UserModelBase {
  id
  first_name
  last_name
  display_name
  email
  phone_number
  account_name
  employee_id
  position
  area
  location
  department
  custom_1
  custom_2
  custom_3
  privacy_policy_accepted
}
    `;
export const VerificationFieldsDocument = gql`
    query verificationFields {
  organisation {
    id
    accountNameLoginConfig {
      fields_config {
        verificationFields
      }
    }
    features {
      account_name_login
    }
  }
}
    `;

/**
 * __useVerificationFieldsQuery__
 *
 * To run a query within a React component, call `useVerificationFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificationFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificationFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerificationFieldsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VerificationFieldsQuery, VerificationFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VerificationFieldsQuery, VerificationFieldsQueryVariables>(VerificationFieldsDocument, options);
      }
export function useVerificationFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VerificationFieldsQuery, VerificationFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VerificationFieldsQuery, VerificationFieldsQueryVariables>(VerificationFieldsDocument, options);
        }
export type VerificationFieldsQueryHookResult = ReturnType<typeof useVerificationFieldsQuery>;
export type VerificationFieldsLazyQueryHookResult = ReturnType<typeof useVerificationFieldsLazyQuery>;
export type VerificationFieldsQueryResult = Apollo.QueryResult<VerificationFieldsQuery, VerificationFieldsQueryVariables>;
export const VerifyUserDocument = gql`
    mutation verifyUser($accountName: NonEmptyString!, $input: UserVerificationDataInput!) {
  organisation {
    userByVerificationData(accountName: $accountName, input: $input) {
      ...userVerificationDetail
      organisation_role
    }
  }
}
    ${UserVerificationDetailFragmentDoc}`;
export type VerifyUserMutationFn = Apollo.MutationFunction<VerifyUserMutation, VerifyUserMutationVariables>;

/**
 * __useVerifyUserMutation__
 *
 * To run a mutation, you first call `useVerifyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserMutation, { data, loading, error }] = useVerifyUserMutation({
 *   variables: {
 *      accountName: // value for 'accountName'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyUserMutation, VerifyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyUserMutation, VerifyUserMutationVariables>(VerifyUserDocument, options);
      }
export type VerifyUserMutationHookResult = ReturnType<typeof useVerifyUserMutation>;
export type VerifyUserMutationResult = Apollo.MutationResult<VerifyUserMutation>;
export type VerifyUserMutationOptions = Apollo.BaseMutationOptions<VerifyUserMutation, VerifyUserMutationVariables>;